export default {
    searchTerm: '',
    imageAssets:{
        'home-top-left-image': null,
        'home-top-right-image': null,
        'home-bottom-left': null,
        'home-bottom-right': null,
        'sidebar-image': null,
    }
};



// WEBPACK FOOTER //
// ./src/store/state.js